import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-80521148"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-wrap" }
const _hoisted_2 = { class: "i-text-message-inner" }

import type { Ref } from 'vue';
import { ref } from 'vue';
import ScAnalyticsApi from '@aab/sc-analytics-api';


export default /*#__PURE__*/_defineComponent({
  __name: 'IText',
  props: {
    withOffset: { type: Boolean, default: false },
    name: { default: '' }
  },
  setup(__props: any) {

const props = __props as { withOffset: boolean, name: string };

const container: Ref<Element | null> = ref(null);



function sendAnalytics(event: Event): void {
  event.stopPropagation();
  if (event.target !== container.value) return;
  ScAnalyticsApi.eventTrack({
    eventName: 'click-itext',
    eventCategory: 'i-text',
    eventAction: `irt: i-text shown: ${props.name}`
  });
}

return (_ctx: any,_cache: any) => {
  const _component_aab_info_popover = _resolveComponent("aab-info-popover")!

  return (_openBlock(), _createBlock(_component_aab_info_popover, {
    ref_key: "container",
    ref: container,
    class: "itext",
    onClick: sendAnalytics
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["i-text-message", { '-offset': __props.withOffset }]),
          role: "tooltip"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 2)
      ])
    ]),
    _: 3
  }, 512))
}
}

})